const translations = {
  "en": {
    "About Us": "About Us",
    "Follow our": "Follow our"
  },
  "zh-tw": {
    "About Us": "關於我們",
    "Follow our": "關注我們的"
  }
};

export default translations;
